import { RowFields, Widget } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import YearsField from './YearsField';

const Employed: FunctionComponent = function () {
  return (
    <>
      <RowFields>
        <Widget.CreditEmploymentDetailsEmployedDetailsEmployerName />
        <Widget.CreditEmploymentDetailsEmployedDetailsMainOccupation />
      </RowFields>
      <YearsField status="employed" />
    </>
  );
};

export default Employed;
